module.exports = __webpack_public_path__ + "static/auto1-group-51f78fdb957279294ddb647753cfdf36.png";